
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/reset-password",
      function () {
        return require("private-next-pages/auth/reset-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/reset-password"])
      });
    }
  